import ModernButton from './ModernButton';

export default ModernButton;
